import { useCallback, useEffect, useRef, useState } from "react";

import { useAxios } from "./useAxios";
import {
  GET_CURRENCIES,
  GET_MARKUP,
  GET_PRODUCTS,
} from "./MoneyConvertor.axios";

const removeDiacritics = (string) => {
  if (!string) return;
  return string
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();
};

const useMoney = ({
  flagsPricingSendities,
  isEnLang,
  lang,
  country_code,
  location,
}) => {
  const countryMatch = country_code.find(({ name }) => {
    let country_name = name.toLowerCase();

    const countryName = (string) => {
      if (!string) return null;
      if (isEnLang) {
        if (string.includes("elsalvador")) {
          return "el salvador";
        }
        if (string.includes("costa-rica")) {
          return "costa rica";
        }
        if (string.includes("dominican-republic")) {
          return "dominican republic";
        }

        return string.replace(" ", "-").toLowerCase();
      }
      if (!isEnLang) {
        if (string.includes("marruecos")) {
          return "morocco";
        }
        if (string.includes("republica-dominicana")) {
          return "dominican republic";
        }
        if (string.includes("el-salvador")) {
          return "el salvador";
        }
        if (string.includes("costa-rica")) {
          return "costa rica";
        }
        if (string.includes("brasil")) {
          return "brazil";
        }

        return string.replace(" ", "-").toLowerCase();
      }
    };
    return countryName(location)?.includes(country_name);
  });

  const [listcountries, setCountries] = useState([]);
  const [countrySelect, setCountrySelect] = useState(
    countryMatch?.code || country_code[0].code,
  );

  const [countrySelectName, setCountrySelectName] = useState("");
  const [countrySelectId, setCountrySelectId] = useState(
    countryMatch?._id || country_code[0]._id,
  );
  const [products, setProducts] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [selectCurrencies, setSelectCurrencies] = useState({});
  const [countryCurrenciestSelectId, setCurrenciesSelectId] = useState(
    countryMatch?.code || country_code[0].code,
  );

  const [agents, setAgents] = useState([]);
  const [selectAgents, setSelectAgents] = useState({});

  const [txt, setTxt] = useState({});
  const [selecTtxt, setSelectTxt] = useState({
    value: " ",
    label: " ",
  });
  const [formError, setFormError] = useState(false);

  const [txtRate, setTxtRate] = useState(0);
  const [commisions, setCommisions] = useState("");
  const [totalHelper, setTotalHelper] = useState("");

  const [moneyInputFirst, setMoneyInputFirst] = useState(0);

  const moneyInputInRef = useRef();
  const moneyInputOutRef = useRef();
  const [selectInput, setSelectInput] = useState(moneyInputInRef);

  const [errorMsg, setErrorMsg] = useState("");

  const { data: SendityMarkup } = useAxios(GET_MARKUP());

  const { data: productsData, loaded: productsLoaded } = useAxios(
    GET_PRODUCTS(countrySelectId),
  );

  const { data, loaded } = useAxios(GET_CURRENCIES(countryCurrenciestSelectId));

  useEffect(() => {
    // countries
    setCountrySelect(countryMatch?.code || country_code[0].code);
    setCountrySelectId(countryMatch?._id || country_code[0]._id);
    setCurrenciesSelectId(countryMatch?.code || country_code[0].code);
    setCountrySelectName(countryMatch?.name || country_code[0].name);
    const mergelistcountires = country_code.map((item) => {
      let name = item.name.toLowerCase().replace(/\s/g, "");

      /* name exceptions for flags */
      if (!isEnLang) {
        if (name === "morocco") name = "marruecos";
        if (name === "dominicanrepublic") name = "republicadominicana";
        if (name === "brazil") name = "brasil";
      }

      const findflag = flagsPricingSendities.country.find(
        ({ title }) =>
          removeDiacritics(title).toLowerCase().replace(/\s/g, "") === name,
      ).flag;

      /* name exceptions for urls */
      if (isEnLang) {
        if (name === "costarica") name = "costa-rica";
        if (name === "dominicanrepublic") name = "dominican-republic";
      }

      if (!isEnLang) {
        if (name === "costarica") name = "costa-rica";
        if (name === "elsalvador") name = "el-salvador";
        if (name === "republicadominicana") name = "republica-dominicana";
      }

      const findUrl = flagsPricingSendities.country.find(({ url }) =>
        removeDiacritics(url).toLowerCase().includes(name),
      ).url;

      let itemmerge = item;
      itemmerge.flag = findflag;
      itemmerge.url = findUrl;
      return itemmerge;
    });

    setCountries(mergelistcountires);
  }, [location, isEnLang]);

  useEffect(() => {
    // products
    if (!productsLoaded || !productsData) return;
    setProducts(productsData.data);
  }, [productsLoaded, productsData]);

  useEffect(() => {
    // currencies

    if (!products) return;

    const uniqueCurrencies = [
      ...new Set(products.map((obj) => obj.destinationCurrency)),
    ];
    const result = uniqueCurrencies.map((currency) => ({
      value: currency,
      label: currency,
    }));
    setCurrencies(result);
    if (typeof result[0] === "undefined") return;
    const seletcted = result[0];
    setSelectCurrencies(seletcted);
  }, [products]);

  useEffect(() => {
    // sucursal agents

    if (!products || !countrySelectName || !selectCurrencies) return;

    const filterproduct = products.filter(
      ({ destinationCurrency }) =>
        destinationCurrency === selectCurrencies.value,
    );
    const uniqueSucursal = [...new Set(filterproduct.map((obj) => obj.agent))];
    const resultagent = uniqueSucursal.map((sucursal) => ({
      value: sucursal,
      label: sucursal,
    }));

    setAgents(resultagent);
    if (typeof resultagent[0] === "undefined") return;
    const seletctedagent = resultagent[0];
    setSelectAgents(seletctedagent);
    firstcalc(products, selectCurrencies, seletctedagent);
    // selected curenci iso

    const isocountry = listcountries.find(
      (item) =>
        item.name.toLowerCase().replace(/\s/g, "") ===
        countrySelectName.toLowerCase().replace(/\s/g, ""),
    );

    setCurrenciesSelectId(isocountry.code);
  }, [products, countrySelectName, selectCurrencies]);

  useEffect(() => {
    // transactionType

    if (!products) return;
    const filterproduct = products.filter(
      (item) => item.destinationCurrency === selectCurrencies.value,
    );

    const uniqueTxt = [
      ...new Set(filterproduct.map((obj) => obj.transactionType)),
    ];
    const resulttxt = uniqueTxt.map((sucursal) => ({
      value: sucursal,
      label: translatefunc(sucursal),
    }));
    setTxt(resulttxt);

    if (typeof resulttxt[0] === "undefined") return;
    const seletctedtxt = resulttxt[0];
    setSelectTxt(seletctedtxt);
  }, [selectCurrencies, products]);

  useEffect(() => {
    const filterproduct = products.filter(
      ({ destinationCurrency, transactionType }) =>
        destinationCurrency === selectCurrencies.value &&
        transactionType === selecTtxt.value,
    );

    const resulttxt = filterproduct.map(({ agent }) => ({
      value: agent,
      label: agent,
    }));

    setAgents(resulttxt);
  }, [selecTtxt]);

  useEffect(() => {
    if (!loaded || !data) return;

    //if there is no rate, use 1 as default
    const txtRateToApply =
      data.data.find(({ iso }) => iso === selectCurrencies.value)?.rate || 1;

    setTxtRate(txtRateToApply);
  }, [countrySelect, data, selectCurrencies, loaded]);

  useEffect(() => {
    // transactionType
    if (
      typeof selectCurrencies.value === "undefined" ||
      typeof selectAgents.value === "undefined"
    )
      return;

    calculate();
  }, [moneyInputFirst, selectAgents, data]);

  useEffect(() => {
    if (formError) {
      moneyInputOutRef.current.style.border = "3px solid #FF0000";
    }
    if (!formError) {
      moneyInputOutRef.current.style.border = "none";
    }
  }, [formError]);

  const translatefunc = (method) => {
    let methodS;
    if (method === "CASH_TO_AGENT")
      methodS = isEnLang
        ? "Cash at specific agent window"
        : "Efectivo en ventanilla de agente específico";
    if (method === "CASH")
      methodS = isEnLang ? "Cash at window" : "Efectivo en ventanilla";
    if (method === "BANK_TRANSFER")
      methodS = isEnLang ? "Bank deposit" : "Depósito bancario";

    // if (method === "BANK_ACCOUNT")
    //   methodS = isEnLang ? "Bank account" : "Cuenta bancaria";
    if (method === "BANK_ACCOUNT")
      methodS = isEnLang ? "MLC Card" : "tarjeta MLC";

    if (method === "MOBILE_MONEY")
      methodS = isEnLang ? "Mobile Wallet" : "Monedero virtual";
    if (method === "ISO20022") methodS = isEnLang ? "MLC Card" : "tarjeta MLC";

    if (method === "HOME_DELIVERY")
      methodS = isEnLang
        ? "Cash delivered at home"
        : "Efectivo entregado en domicilio";
    if (method === "ATM")
      methodS = isEnLang ? "ATM pick up" : "Recogida en ATM";

    return methodS;
  };

  const findInput = useCallback(async (field) => {
    setSelectInput(field === "input-text" ? moneyInputInRef : moneyInputOutRef);
  }, []);

  const countryHandlerMoney = (value) => {
    setCountrySelect(value);

    setCountrySelectId(
      country_code.find((item) => item.code === value)._id ||
        country_code[0]._id,
    );
    setCountrySelectName(
      country_code.find((item) => item.code === value).name ||
        country_code[0].name,
    );
  };
  const currencyHandlerMoney = (value) => {
    setSelectCurrencies(value);
    calculate(value);
  };
  const agentsHandlerMoney = (value) => {
    setSelectAgents(value);
  };

  const txtHandlerMoney = (value) => {
    setSelectTxt(value);

    const objetosFiltrados = productsData.data.filter(
      ({ transactionType, destinationCurrency }) =>
        transactionType === value.value &&
        destinationCurrency === selectCurrencies.value,
    )[0].agent;

    setSelectAgents({ value: objetosFiltrados, label: objetosFiltrados });
    calculate();
  };

  const handleMoneyInputChange = ({ target }) => {
    // if (isNaN(target.value)) return
    // if (target.value.includes(",")) {
    //   target.value = target.value.replace(",", ".")
    // }
    if (target.value === "" || target.value === "0") {
      moneyInputOutRef.current.value = 0;
      setCommisions(0);
      setTotalHelper(0);
    }

    calculate();
  };

  const handleMoneyOutputChange = ({ target }) => {
    // console.log(Number(target.value))
    // if (target.value.includes(",")) {
    //   target.value = target.value.replace(",", ".")
    // }

    if (target.value === "" || target.value === "0") {
      moneyInputInRef.current.value = 0;
      setCommisions(0);
      setTotalHelper(0);
    }

    if (
      (moneyInputInRef.current.value === "" ||
        moneyInputInRef.current.value === "0") &&
      target.value !== "0"
    ) {
      moneyInputInRef.current.value = 1;
    }

    calculate();
  };

  const onSubmit = async () => {
    // console.log({
    //   data: {
    //     country: countrySelectName,
    //     currency: selectCurrencies.value,
    //     calculator: true,
    //   },
    // })
    try {
      // await axios({
      //   method: "POST",
      //   url: `${process.env.GATSBY_CONNECTIF}?eventAlias=use-calculator`,
      //   data: {
      //     country: countrySelectName,
      //     currency: selectCurrencies.value,
      //     calculator: true,
      //   },
      // });
    } finally {
      window.location.href = `https://payments.sendity.com/login?lang=${lang}`;
      //form here we can controll error when user submit
      // navigate("https://payments.sendity.com/signup")
    }
    if (formError) {
      return console.log("no enviar form, resaltar campos");
    }
    // console.log(
    //   { selectCountry },
    //   { selectCurrency },
    //   { selectSucursalAgent },
    //   { selectTXType },
    //   { moneyInput },
    //   { moneyOutput }
    // )
  };

  const errorsHandler = ({
    minAmount,
    maxAmount,
    outputValue,
    selectCurrencies,
    countrySelectName,
    txtType,
    multipleOf,
  }) => {
    const outputNumber = parseFloat(outputValue);

    const outputIsLessThanMinAmount = outputNumber < (minAmount || 1);
    const outputIsGreaterThanMaxAmount = outputNumber > (maxAmount || Infinity);

    if (outputIsLessThanMinAmount || outputIsGreaterThanMaxAmount) {
      setFormError(true);

      const msjWithoutMin = isEnLang
        ? `please enter a value smaller than ${maxAmount?.toLocaleString()} ${
            selectCurrencies.value
          }`
        : `por favor, introduce un valor menor que ${maxAmount?.toLocaleString()} ${
            selectCurrencies.value
          }`;

      const msjWithoutMax = isEnLang
        ? `please enter a value greater than ${minAmount?.toLocaleString()} ${
            selectCurrencies.value
          }`
        : `por favor, introduce un valor mayor que ${minAmount?.toLocaleString()} ${
            selectCurrencies.value
          }`;

      const msjWithMinAndMax = isEnLang
        ? `please enter a value greater than ${minAmount?.toLocaleString()} ${
            selectCurrencies.value
          } and less than ${maxAmount?.toLocaleString()} ${
            selectCurrencies.value
          }`
        : `por favor, introduce un valor mayor que ${minAmount?.toLocaleString()} ${
            selectCurrencies.value
          } y menor ${maxAmount?.toLocaleString()} ${selectCurrencies.value}`;

      let msj;

      if (minAmount && maxAmount) {
        msj = msjWithMinAndMax;
      }
      if (!minAmount) {
        msj = msjWithoutMin;
      }
      if (!maxAmount) {
        msj = msjWithoutMax;
      }

      setErrorMsg(msj);
      return;
    }

    const hasMultipleOfCondition =
      Boolean(multipleOf) && typeof multipleOf === "number";
    const multipleOfIsNotValid = outputNumber % multipleOf !== 0;

    if (hasMultipleOfCondition) {
      if (multipleOfIsNotValid) {
        setFormError(true);
        if (multipleOf === 1) {
          setErrorMsg(
            isEnLang
              ? `The amount that arrives at the destination must be an integer`
              : `El importe que llega no puede tener decimales`,
          );
          return;
        }
        setErrorMsg(
          isEnLang
            ? `The amount that arrives at the destination must be a multiple of ${multipleOf}`
            : `El importe que llega a destino deberá ser múltiplo de ${multipleOf}`,
        );
        return;
      }
    }

    setFormError(false);
    setErrorMsg("");
  };

  const firstcalc = (productsData, selectCurrencies, seletctedagent) => {
    // seleccionar el producto con la moneda más baja.
    const objetosFiltrados = productsData.filter((objeto) => {
      return (
        objeto.destinationCurrency === selectCurrencies.value &&
        objeto.agent === seletctedagent.value &&
        objeto.fees.sort((a, b) => a.minAmount - b.minAmount)
      );
    });

    // luego añadir a envias la moneda más baja multiplos 100
    let firstQuntity = 0;
    if (
      objetosFiltrados[0].fees[0]?.minAmount === null ||
      objetosFiltrados[0].fees[0]?.minAmount <= 100
    ) {
      firstQuntity = 100;
    } else {
      firstQuntity =
        Math.ceil(objetosFiltrados[0].fees[0]?.minAmount / 100) * 100;
    }

    moneyInputInRef.current.value = firstQuntity;
    setMoneyInputFirst(firstQuntity);
  };

  const calculate = (currency) => {
    // saber que cantidad tengo seleccionada
    const Quantity =
      selectInput.current.name === "input-text"
        ? moneyInputInRef.current
        : moneyInputOutRef.current;

    // saber la moneda
    let selectCur = selectCurrencies.value;
    if (typeof currency !== "undefined") {
      selectCur = currency.value;
    }

    // saber el agente
    const selectA = selectAgents.value;

    // necesito tener seleccionado el tenant que es segun la cantidad
    const objetosFiltrados = products.filter(
      ({ destinationCurrency, agent, fees }) =>
        destinationCurrency === selectCur &&
        agent === selectA &&
        fees.filter(({ minAmount }) => minAmount <= Quantity.valueAsNumber) &&
        fees.filter(({ maxAmount }) => maxAmount >= Quantity.valueAsNumber),
    );
    if (!data) return;

    change({ selectCur, objetosFiltrados, inputValue: Quantity });
  };
  const change = async ({ selectCur, objetosFiltrados, inputValue }) => {
    let rate = 1;

    if (selectCur !== "EUR") {
      rate = data.data.find((item) => item.iso === selectCur)?.rate;
    }

    const { exchangeMarkup } = (await SendityMarkup?.data) || {};

    const result = 1 / (rate + (rate * parseFloat(exchangeMarkup)) / 100);

    setTxtRate(result);
    rate = 1 / result;

    comisions({ objetosFiltrados, rate, inputValue });
  };

  const comisions = ({ objetosFiltrados, rate, inputValue }) => {
    const matchedOperation = objetosFiltrados.find(
      ({ transactionType }) => transactionType === selecTtxt.value,
    );

    if (!matchedOperation || typeof rate === "undefined") return;
    //this matchedOperationFees is Revolu fees for the exchanges
    //value input Minamount = mayor, y el input value es = menos maxAmount

    const matchedOperationFees = matchedOperation.fees.find(
      ({ minAmount, maxAmount }) => {
        if (inputValue.name === "input-text") {
          return (
            parseFloat(moneyInputInRef.current.valueAsNumber) >=
              Number(minAmount || 1) &&
            parseFloat(moneyInputInRef.current.valueAsNumber) <=
              Number(maxAmount || Infinity)
          );
        }

        if (inputValue.name !== "input-text") {
          return (
            parseFloat(moneyInputOutRef.current.valueAsNumber) * rate >=
              Number(minAmount || 1) &&
            parseFloat(moneyInputOutRef.current.valueAsNumber) * rate <=
              Number(maxAmount || Infinity)
          );
        }

        return false; // Default return value in case no conditions are met
      },
    );

    if (!matchedOperationFees) return;

    let fixed;
    let variableTax;
    let commisionsValue;
    let netValueToExchange;

    //tenants is for Sendity
    const { revenueFixedAmount, revenuePercentage } = matchedOperation.tenants;
    // this are Revolu fees for the exchange
    const { costFixedAmount, costPercentage } = matchedOperationFees;

    const txtRatenumber = parseFloat(rate);
    const RevoluFixed = Number(costFixedAmount);
    const RevoluVar = Number(costPercentage);
    const sendityFixed = Number(revenueFixedAmount);
    const sendityVar = Number(revenuePercentage);

    if (inputValue.name === "input-text") {
      // if (countrySelectName === "Cuba") {
      //   // const USDtoEUR = txtRatenumber;
      //   const USDtoEUR = 1;
      //   const EURtoUSD = 1 / txtRatenumber;

      //   // fixed = RevoluFixed * USDtoEUR + sendityFixed;
      //   fixed = RevoluFixed + sendityFixed;

      //   const variableTaxAsPercentage = sendityVar + RevoluVar;
      //   const varAsNumber = variableTaxAsPercentage / 100;

      //   const calculatedBase =
      //     (inputValue.valueAsNumber - fixed) / (1 + varAsNumber);
      //   netValueToExchange = calculatedBase;
      //   variableTax = calculatedBase * (sendityVar / 100 + RevoluVar / 100);
      //   commisionsValue = fixed + variableTax;
      //   const total = (netValueToExchange * EURtoUSD).toFixed(2);

      //   moneyInputOutRef.current.value = total > 0 ? Number(total) : 0;
      // }

      // if (countrySelectName !== "Cuba") {
      // calculate fixed and variable fees
      fixed = sendityFixed + RevoluFixed;

      const variableTaxAsPercentage = (sendityVar + RevoluVar) / 100;

      // first check for total without fixed fees
      const inputWithoutFixed = inputValue.valueAsNumber - fixed;

      // then the calculate the net ammount to exchage
      netValueToExchange = Number(
        inputWithoutFixed / (1 + variableTaxAsPercentage),
      );

      //having the net value (netValueToExchange), then we use it to calculate the variableTax
      variableTax = variableTaxAsPercentage * netValueToExchange;

      //now we calculate the comissions
      commisionsValue = fixed + variableTax;

      const total = Number((netValueToExchange / txtRatenumber).toFixed(2));

      //this will be the ammount sent to the client
      moneyInputOutRef.current.value = total > 0 ? total : 0;
      // }
    }

    if (inputValue.name === "output-text") {
      // if (countrySelectName === "Cuba") {
      //   // fixed = RevoluFixed * txtRatenumber + sendityFixed;
      //   fixed = RevoluFixed + sendityFixed;

      //   const calculatedBase = inputValue.valueAsNumber * txtRatenumber;
      //   netValueToExchange = calculatedBase;
      //   variableTax = calculatedBase * (sendityVar / 100 + RevoluVar / 100);
      //   commisionsValue = fixed + variableTax;

      //   const total = (netValueToExchange + commisionsValue).toFixed(2);

      //   moneyInputInRef.current.value = Number(total);
      // }

      // if (countrySelectName !== "Cuba") {
      fixed = sendityFixed + RevoluFixed;
      const variableTaxAsPercentage = sendityVar + RevoluVar;
      const variableTaxAsNumber = variableTaxAsPercentage / 100;
      variableTax = variableTaxAsNumber;

      const totalconvert = inputValue.valueAsNumber * txtRatenumber;

      netValueToExchange = totalconvert;

      const totalvariable = totalconvert * variableTax;
      commisionsValue = totalvariable + fixed;

      const totalSendValue = (totalconvert + commisionsValue).toFixed(2);
      moneyInputInRef.current.value = Number(totalSendValue);
      // }
    }

    const { minAmount, maxAmount, multipleOf } = matchedOperation;

    setCommisions(commisionsValue);
    setTotalHelper(netValueToExchange);

    errorsHandler({
      minAmount,
      maxAmount,
      outputValue: moneyInputOutRef.current.valueAsNumber,
      selectCurrencies,
      countrySelectName,
      txtType: matchedOperation.transactionType,
      multipleOf,
    });
  };

  return {
    listcountries,
    countrySelect,
    countryHandlerMoney,
    countrySelectName,
    currencies,
    currencyHandlerMoney,
    selectCurrencies,
    agents,
    agentsHandlerMoney,
    selectAgents,
    txt,
    txtHandlerMoney,
    selecTtxt,
    handleMoneyInputChange,
    handleMoneyOutputChange,
    findInput,
    moneyInputFirst,
    moneyInputInRef,
    moneyInputOutRef,
    onSubmit,
    formError,
    errorMsg,
    txtRate,
    commisions,
    totalHelper,
  };
};

export default useMoney;
